export enum AuthRole {
  TenantAdmin = 'tenant_admin',
  SuperAdmin = 'super_admin',
}

export const ADMIN_ROLES = [AuthRole.TenantAdmin, AuthRole.SuperAdmin] as const
